export default {
  methods: {
    repliersToSelectItem(repliers = []) {
      return repliers.map(({ name, id }) => ({
        text: name,
        value: id,
      }));
    },
  },
};
